export default (fieldsToRemove, objectToUpdate) => {
  fieldsToRemove.forEach((e) => delete objectToUpdate[e])
  return objectToUpdate
}
